// extracted by mini-css-extract-plugin
export default {"notification":"DataUploadNotification_notification__BhsUD"};